var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncoming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2187 28.8672C15.456 29.6299 15.456 30.8662 16.2187 31.6289C16.9814 32.3916 18.2178 32.3916 18.9805 31.6289L24.2285 26.3809C24.9971 25.6123 24.9814 24.3721 24.2285 23.6191L18.9805 18.3711C18.2178 17.6084 16.9814 17.6084 16.2187 18.3711C15.456 19.1338 15.456 20.3701 16.2187 21.1338L18.1328 23.0479L1.95312 23.0469C0.874023 23.0469 0 23.9209 0 25C0 26.0791 0.874023 26.9531 1.95312 26.9531H18.1328L16.2187 28.8672Z",
    fill: "#4CCD8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1172 0H13.2812C12.2021 0 11.3281 0.874023 11.3281 1.95312V9.375C11.3281 10.4541 12.2021 11.3281 13.2812 11.3281C14.3604 11.3281 15.2344 10.4541 15.2344 9.375V3.90625H43.1641V46.0938H15.2344V40.625C15.2344 39.5459 14.3604 38.6719 13.2812 38.6719C12.2021 38.6719 11.3281 39.5459 11.3281 40.625V48.0469C11.3281 49.126 12.2021 50 13.2812 50H45.1172C46.1963 50 47.0703 49.126 47.0703 48.0469V1.95312C47.0703 0.874023 46.1963 0 45.1172 0Z",
    fill: "#0E3368"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoming);
export default __webpack_public_path__ + "static/media/incoming.53371eb8.svg";
export { ForwardRef as ReactComponent };